// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';

var _defineProperty = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('url'),
    URL = _require.URL;

var debug = require('debug')('elasticsearch');

var Connection = require('../Connection');

var noop = function noop() {};

var BaseConnectionPool = /*#__PURE__*/function () {
  function BaseConnectionPool(opts) {
    _classCallCheck(this, BaseConnectionPool);

    // list of nodes and weights
    this.connections = []; // how many nodes we have in our scheduler

    this.size = this.connections.length;
    this.Connection = opts.Connection;
    this.emit = opts.emit || noop;
    this.auth = opts.auth || null;
    this._ssl = opts.ssl;
    this._agent = opts.agent;
  }

  _createClass(BaseConnectionPool, [{
    key: "getConnection",
    value: function getConnection() {
      throw new Error('getConnection must be implemented');
    }
  }, {
    key: "markAlive",
    value: function markAlive() {
      return this;
    }
  }, {
    key: "markDead",
    value: function markDead() {
      return this;
    }
    /**
     * Creates a new connection instance.
     */

  }, {
    key: "createConnection",
    value: function createConnection(opts) {
      if (typeof opts === 'string') {
        opts = this.urlToHost(opts);
      }

      if (this.auth !== null) {
        opts.auth = this.auth;
      } else if (opts.url.username !== '' && opts.url.password !== '') {
        opts.auth = {
          username: decodeURIComponent(opts.url.username),
          password: decodeURIComponent(opts.url.password)
        };
      }

      if (opts.ssl == null) opts.ssl = this._ssl;
      if (opts.agent == null) opts.agent = this._agent;
      var connection = new this.Connection(opts);

      var _iterator = _createForOfIteratorHelper(this.connections),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var conn = _step.value;

          if (conn.id === connection.id) {
            throw new Error("Connection with id '".concat(connection.id, "' is already present"));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return connection;
    }
    /**
     * Adds a new connection to the pool.
     *
     * @param {object|string} host
     * @returns {ConnectionPool}
     */

  }, {
    key: "addConnection",
    value: function addConnection(opts) {
      var _this = this;

      if (Array.isArray(opts)) {
        return opts.forEach(function (o) {
          return _this.addConnection(o);
        });
      }

      if (typeof opts === 'string') {
        opts = this.urlToHost(opts);
      }

      var connectionById = this.connections.find(function (c) {
        return c.id === opts.id;
      });
      var connectionByUrl = this.connections.find(function (c) {
        return c.id === opts.url.href;
      });

      if (connectionById || connectionByUrl) {
        throw new Error("Connection with id '".concat(opts.id || opts.url.href, "' is already present"));
      }

      this.update([].concat(_toConsumableArray(this.connections), [opts]));
      return this.connections[this.size - 1];
    }
    /**
     * Removes a new connection to the pool.
     *
     * @param {object} connection
     * @returns {ConnectionPool}
     */

  }, {
    key: "removeConnection",
    value: function removeConnection(connection) {
      debug('Removing connection', connection);
      return this.update(this.connections.filter(function (c) {
        return c.id !== connection.id;
      }));
    }
    /**
     * Empties the connection pool.
     *
     * @returns {ConnectionPool}
     */

  }, {
    key: "empty",
    value: function empty(callback) {
      var _this2 = this;

      debug('Emptying the connection pool');
      var openConnections = this.size;
      this.connections.forEach(function (connection) {
        connection.close(function () {
          if (--openConnections === 0) {
            _this2.connections = [];
            _this2.size = _this2.connections.length;
            callback();
          }
        });
      });
    }
    /**
     * Update the ConnectionPool with new connections.
     *
     * @param {array} array of connections
     * @returns {ConnectionPool}
     */

  }, {
    key: "update",
    value: function update(nodes) {
      var _this3 = this;

      debug('Updating the connection pool');
      var newConnections = [];
      var oldConnections = [];

      var _iterator2 = _createForOfIteratorHelper(nodes),
          _step2;

      try {
        var _loop = function _loop() {
          var node = _step2.value;

          // if we already have a given connection in the pool
          // we mark it as alive and we do not close the connection
          // to avoid socket issues
          var connectionById = _this3.connections.find(function (c) {
            return c.id === node.id;
          });

          var connectionByUrl = _this3.connections.find(function (c) {
            return c.id === node.url.href;
          });

          if (connectionById) {
            debug("The connection with id '".concat(node.id, "' is already present"));

            _this3.markAlive(connectionById);

            newConnections.push(connectionById); // in case the user has passed a single url (or an array of urls),
            // the connection id will be the full href; to avoid closing valid connections
            // because are not present in the pool, we check also the node url,
            // and if is already present we update its id with the ES provided one.
          } else if (connectionByUrl) {
            connectionByUrl.id = node.id;

            _this3.markAlive(connectionByUrl);

            newConnections.push(connectionByUrl);
          } else {
            newConnections.push(_this3.createConnection(node));
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var ids = nodes.map(function (c) {
        return c.id;
      }); // remove all the dead connections and old connections

      var _iterator3 = _createForOfIteratorHelper(this.connections),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var connection = _step3.value;

          if (ids.indexOf(connection.id) === -1) {
            oldConnections.push(connection);
          }
        } // close old connections

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      oldConnections.forEach(function (connection) {
        return connection.close();
      });
      this.connections = newConnections;
      this.size = this.connections.length;
      return this;
    }
    /**
     * Transforms the nodes objects to a host object.
     *
     * @param {object} nodes
     * @returns {array} hosts
     */

  }, {
    key: "nodesToHost",
    value: function nodesToHost(nodes, protocol) {
      var ids = Object.keys(nodes);
      var hosts = [];

      for (var i = 0, len = ids.length; i < len; i++) {
        var _Object$assign;

        var node = nodes[ids[i]]; // If there is no protocol in
        // the `publish_address` new URL will throw
        // the publish_address can have two forms:
        //   - ip:port
        //   - hostname/ip:port
        // if we encounter the second case, we should
        // use the hostname instead of the ip

        var address = node.http.publish_address;
        var parts = address.split('/'); // the url is in the form of hostname/ip:port

        if (parts.length > 1) {
          var hostname = parts[0];
          var port = parts[1].match(/((?::))(?:[0-9]+)$/g)[0].slice(1);
          address = "".concat(hostname, ":").concat(port);
        }

        address = address.slice(0, 4) === 'http' ? address : "".concat(protocol, "//").concat(address);
        var roles = node.roles.reduce(function (acc, role) {
          acc[role] = true;
          return acc;
        }, {});
        hosts.push({
          url: new URL(address),
          id: ids[i],
          roles: Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, Connection.roles.MASTER, false), _defineProperty(_Object$assign, Connection.roles.DATA, false), _defineProperty(_Object$assign, Connection.roles.INGEST, false), _defineProperty(_Object$assign, Connection.roles.ML, false), _Object$assign), roles)
        });
      }

      return hosts;
    }
    /**
     * Transforms an url string to a host object
     *
     * @param {string} url
     * @returns {object} host
     */

  }, {
    key: "urlToHost",
    value: function urlToHost(url) {
      return {
        url: new URL(url)
      };
    }
  }]);

  return BaseConnectionPool;
}();

module.exports = BaseConnectionPool;